import React from 'react';
const ColorPicker = (props) => {
    return React.createElement("input", { type: 'color' });
};
if (process.env.NODE_ENV !== 'production') {
    ColorPicker.displayName = 'ColorPicker';
}
export default ColorPicker;
//# sourceMappingURL=index.js.map